import { use42ChatLogo } from './hooks/use42ChatLogo'

const LogoProgress = () => {
  use42ChatLogo()
  return null
}

export default LogoProgress
